import React, { useState } from 'react'

export const SpotCheckLabel = ({ value, x, index, hideTooltip }) => {
  const [inFront, setInFront] = useState(false)
  function changeDisplay(toFront) {
    setInFront(toFront)
  }
  //if blood presure contact sys to dia by index
  return value ?
    <>
      <svg style={{ opacity: inFront ? 1 : 0 }} onMouseOut={() => changeDisplay(false)} onMouseOver={() => changeDisplay(true)} x={x - (inFront ? 70 : 25)} y={inFront ? 0 : 15/* 25 */}>
        <g>
          <rect rx={5} width={inFront ? 62 : 52} height={inFront ? 40 : 30} fill={inFront ? '#c6cad5' : 'white'} stroke='#9AC03B' strokeWidth="2" > </rect>
          <text x={inFront ? '32' : '25'} y={inFront ? '28' : '20'} textAnchor="middle" fontSize={inFront ? '17' : '13'} fill="black">{value}</text>
        </g>
      </svg>
      <svg className='rect' style={{ opacity: inFront ? 0 : 1 }} onMouseOut={() => changeDisplay(false)} onMouseOver={() => changeDisplay(true)} x={x - (25)} y={15/* 25 */}>
        <g>
          <rect rx={5} width={52} height={30} fill={'white'} stroke='#9AC03B' strokeWidth="2" > </rect>
          <text x={'25'} y={'20'} textAnchor="middle" fontSize={'13'} fill="black">{value}</text>
        </g>
      </svg>
    </>
    : ''
}

export const ContinuesLabel = (props) => {
  const { value, x, y, index, strokeColor, show, hideTooltip } = props
  const [inFront, setInFront] = useState(false)
  function changeDisplay(toFront) {
    if(toFront)hideTooltip(false)
    else hideTooltip(true)
    setInFront(toFront)
  }
  return show(value, index) ?
    <>
    {/* the first svg show on mouse over the second gone - this beacuse else its shivering...  */}
      <svg style={{ opacity: inFront ? 1 : 0 }}  onMouseOut={() => changeDisplay()} onMouseOver={() => changeDisplay(true)} x={x - (inFront ? 60 : 18)} y={y - (inFront ? 30 : 18)}>
        <g>
          <circle cx={inFront ? '28' : '18'} cy={inFront ? '28' : '18'} r={inFront ? '27' : '17'} fill={inFront ? '#c6cad5' : 'white'} stroke={strokeColor} strokeWidth="2" />
          <text x={inFront ? '28' : '18'} y={inFront ? '35' : '22'} textAnchor="middle" fontSize={inFront ? '20' : '13'} fill="black">{value}</text>
        </g>
      </svg>
      <svg className='circle' style={{ opacity: inFront ? 0 : 1 }} onMouseOut={() => changeDisplay()} onMouseOver={() => changeDisplay(true)} x={x - 18} y={y - 18}>
        <g>
          <circle cx={'18'} cy={'18'} r={'17'} fill={'white'} stroke={strokeColor} strokeWidth="2" />
          <text x={'18'} y={'22'} textAnchor="middle" fontSize={'13'} fill="black">{value}</text>
        </g>
      </svg>
    </>
    : ''
}